import { useLayoutEffect, type RefObject } from 'react';

/**
 * CORE-311 — the mobile-web composer starts one line tall and grows with its
 * text up to `max`, then scrolls inside.
 *
 * RNW's `onContentSizeChange` can't do this: it reports `scrollHeight`, which
 * never drops below the textarea's own height, so the field would grow but not
 * shrink back after sending. Here the height is reset first, then measured.
 *
 * On RNW the TextInput ref IS the `<textarea>`. `enabled` is false off mobile
 * web, and the inline height is cleared when it turns false.
 */
export function useComposerAutoGrow(
  ref: RefObject<unknown>,
  value: string,
  enabled: boolean,
  min: number,
  max: number,
) {
  useLayoutEffect(() => {
    const el = ref.current as HTMLTextAreaElement | null;
    if (!enabled || !el?.style) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(Math.max(el.scrollHeight, min), max)}px`;
    return () => { el.style.height = ''; };
  }, [ref, value, enabled, min, max]);
}
